module.exports = __webpack_public_path__ + "static/media/open-link.c900f4c4.svg";